export default {
    install(Vue, options) {
        Vue.prototype.$getSearchPageLink = function (searchPageLink, searchQuery) {
            if(!searchPageLink || !searchQuery) return;

            return `${searchPageLink}?q=${encodeURIComponent(searchQuery)}`;
        }
    }
}